import { Component, OnInit } from '@angular/core';
import { RestService } from '../../services/rest.service';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  changeColor: boolean = true;
  show: boolean = false;

  constructor(private restService: RestService, public router: Router) {
  }

  ngOnInit() {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {

        if (
          (event.url.includes('/welcome') || event.urlAfterRedirects.includes('/welcome'))
        ) {
          this.changeColor = true;
        } else {
          this.changeColor = false;
        }

      }
    });
    this.permission();
  }

  user_logout() {
    this.restService.user_logout();
    this.router.navigateByUrl('/signin');
  }

  closeMenu(e) {
    e.target.closest('.dropdown').classList.remove('show');
    e.target.closest('.dropdown .dropdown-menu').classList.remove('show');
  }

  toggleSidebar(event) {
    event.preventDefault();
    if (window.matchMedia('(min-width: 992px)').matches) {
      document.querySelector('body').classList.toggle('az-sidebar-hide');
    } else {
      document.querySelector('body').classList.toggle('az-sidebar-show');
    }
  }

  permission() {
    this.restService.user_validate("PROFILE").subscribe(data => {
      if (data.success) {
        this.show = data.success;
      } else {
        this.show = false;
      }
    }, err => {
      this.show = false;
    });
  }

}
